/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { FETCH_CHECKFUND_EXHAUSTED } from './actionTypes';

import { fetchCheckfundExhaustedUtil } from './utils';

/**
 * Contains the action creator functions that update the ACESFund slice of the store.
 *
 * @namespace ACESFundActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/checkfundExhausted
   *
   * @param {string} intakeApplicationTypeId.
   * @param {any} callback function to call once this function has finished
   * @function
   * @memberof ACESFundActions
   */
  static fetchCheckfundExhausted = (dispatch, intakeApplicationTypeId, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      fetchCheckfundExhaustedUtil.bind(null, intakeApplicationTypeId),

      FETCH_CHECKFUND_EXHAUSTED,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to fetchCheckfundExhausted.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof ACESFundActions
   */
  static resetFetchCheckfundExhausted = (dispatch, data) => {
    const json = {
      type: FETCH_CHECKFUND_EXHAUSTED.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to fetchCheckfundExhausted.
   *
   * @param {function} dispatch
   * @function
   * @memberof ACESFundActions
   */
  static resetFetchCheckfundExhaustedError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, FETCH_CHECKFUND_EXHAUSTED.failureAction);
  };
}
